export default __webpack_public_path__ + "static/media/step3_img1.ab344c23.png";